// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import PasswordTextBoxTemplate from '@front/templates/PasswordTextBoxTemplate.html';
import { TextBoxEvents } from '../../Controls/elements/TerceraTextBox';
import { Resources } from '@shared/localizations/Resources';
import { IsPasteEvent } from '@shared/commons/KeyEventProcessor';
import { ContainerControl } from './ContainerControl';
export class PasswordTextBox extends ContainerControl {
    constructor() {
        super();
        this.wasPaste = false;
    }
    getType() {
        return ControlsTypes.PasswordTextBox;
    }
    oninit() {
        super.oninit();
        super.on('showPassEye_btnClick', this.showPassEye_btnClick);
        super.on('showPassEye_btnHover', this.showPassEye_btnHover);
    }
    oncomplete() {
        super.oncomplete();
        this.subscribeControlsEvents();
        this.localize();
    }
    isPasswordTextBox(control) {
        const type = control.getType();
        const result = [ControlsTypes.TerceraTextBox, ControlsTypes.InvestingTextBox].includes(type);
        return result;
    }
    subscribeControlsEvents() {
        for (const ID in this.Controls) {
            const control = this.Controls[ID];
            if (this.isPasswordTextBox(control)) {
                this.textBox = control;
            }
        }
        this.textBox.on('keyDown', this.onKeyDown.bind(this));
        const input = this.textBox.getInputElement();
        input.addEventListener('input', (ev) => {
            if (this.wasPaste || ev.inputType === 'insertFromPaste') {
                input.value = input.value.trim();
            }
            this.wasPaste = false;
        });
    }
    onKeyDown(context) {
        const ev = context.event;
        if (IsPasteEvent(ev)) {
            this.wasPaste = true;
        }
        super.fire(TextBoxEvents.KeyDown, context);
    }
    showPassEye_btnClick() {
        const eyeNotCrossed = Boolean(super.get('passwordHided'));
        void super.set('passwordHided', !eyeNotCrossed);
    }
    showPassEye_btnHover(context) {
        const event = context.event;
        if (event.currentTarget === event.target) {
            return;
        }
        const newEvent = new MouseEvent(event.type);
        Object.defineProperty(newEvent, 'target', { value: event.currentTarget, writable: false });
        event.currentTarget.dispatchEvent(newEvent);
    }
    getInputElement() {
        return this.textBox.getInputElement();
    }
    localize() {
        void super.set({
            showPassEyeTooltip: Resources.getResource('screen.LoginScreen.ShowPassEye.ToolTip'),
            hidePassEyeCrossedTooltip: Resources.getResource('screen.LoginScreen.ShowPassCrossed.ToolTip')
        });
    }
}
ContainerControl.extendWith(PasswordTextBox, {
    template: PasswordTextBoxTemplate,
    data: function () {
        return {
            showPasswordPreview: false,
            passwordHided: true,
            focused: false,
            showPassEyeTooltip: '',
            hidePassEyeCrossedTooltip: '',
            isMaterialDesign: true
        };
    }
});
